module.exports = __webpack_public_path__ + "img/botonPinguino.png.6609aae6.webp";